import { BodyStyle } from 'components/styled/typography/styles'
import React from 'react'
import { Control } from 'react-redux-form'
import styled, { css } from 'styled-components'

export interface StyledTextInputProps {
  id?: string
  model?: any
  defaultValue?: string
  type?: string
  autoComplete?: string
  changeAction?: () => void
  children?: React.ReactNode | React.ReactNode[]
  className?: string
  content?: string
  maxLength?: number
  placeholder?: string
  readOnly?: boolean
  disabled?: boolean
  onPaste?: (event: React.ClipboardEvent<HTMLInputElement>) => void
  onChange?: (event: React.FormEvent<HTMLInputElement>) => void
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void
  updateOn?: any
  validateOn?: any
  validators?: any
  inputRef?: any
  onFocus?: () => void
  onBlur?: () => void
}

export const PlaceholderStyle = css`
  ${BodyStyle};
  color: ${({ theme }) => theme.color.grey90};
  font-style: italic;
  opacity: 1; /* Firefox requires */
`

export const InputStyle = css`
  background-color: ${({ theme }) => theme.color.grey07};
  border: none;
  border-radius: 0;
  box-shadow: none;
  color: ${({ theme }) => theme.color.bodyText};
  height: auto;
  align-items: center;
  display: flex;
  height: ${({ theme }) => theme.space.s40};
  line-height: ${({ theme }) => theme.space.s24};
  width: 100%;
  padding: ${({ theme }) => theme.space.s8} ${({ theme }) => theme.space.s16};
  outline: none;

  &:disabled {
    background-color: ${({ theme }) => theme.color.grey20};
    cursor: not-allowed;
  }

  /* Chrome, Firefox, Opera, Safari 10.1+ */
  ::placeholder {
    ${PlaceholderStyle};
  }

  /* Microsoft Edge */
  ::-ms-input-placeholder {
    ${PlaceholderStyle};
  }

  &:focus {
    box-shadow: none !important;
    outline: none !important;
  }
`

export const InputControlField = styled(Control.text)`
  ${InputStyle};
`

export const InputField = styled.input`
  ${InputStyle};
`

export const StyledTextInput = ({
  model,
  type = 'text',
  autoComplete,
  changeAction,
  children,
  className,
  content,
  maxLength,
  placeholder,
  readOnly = false,
  disabled = false,
  onPaste,
  onChange,
  onKeyPress,
  updateOn = 'change',
  validateOn = 'change',
  validators,
  inputRef,
  ...props
}: StyledTextInputProps) => {
  if (model) {
    return (
      <>
        <InputControlField
          {...props}
          model={model}
          type={type}
          aria-label={model}
          autoComplete={autoComplete}
          changeAction={changeAction}
          className={className}
          content={content}
          maxLength={maxLength}
          placeholder={placeholder}
          readOnly={readOnly}
          disabled={disabled}
          onPaste={onPaste}
          onChange={onChange}
          onKeyPress={onKeyPress}
          updateOn={updateOn}
          validateOn={validateOn}
          validators={validators}
        />
        {children}
      </>
    )
  }
  return (
    <>
      <InputField
        {...props}
        type={type}
        ref={inputRef}
        autoComplete={autoComplete}
        aria-label={model}
        disabled={disabled}
        className={className}
        maxLength={maxLength}
        placeholder={placeholder}
        onPaste={onPaste}
        onChange={onChange}
        onKeyPress={onKeyPress}
      />
      {children}
    </>
  )
}
